// extracted by mini-css-extract-plugin
export default {"title":"styles-module__title___i0JVT","description":"styles-module__description___ZpsE0"};